import { createSlice } from '@reduxjs/toolkit';
import { getRelatedReportApi } from '../../../rtk-apis/relatedReports/getRelatedReport';

const initialState = {
  status: '',
  result: [],
  msg: '',
  loading: false,
};

const getRelatedReportSlice = createSlice({
  name: 'getRelatedReports',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = [];
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getRelatedReportApi.pending, (state, action) => {
        state.status = 'LOADING';
        state.loading = true;
      })
      .addCase(getRelatedReportApi.fulfilled, (state, action) => {
        console.log(action);
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action?.payload?.result?.list;
        state.msg = action?.payload?.msg;
      })
      .addCase(getRelatedReportApi.rejected, (state, action: any) => {
        state.loading = false;
        state.status = 'FAILED';
        state.msg = (action?.payload as string) || 'Something went wrong';
      });
  },
});

export default getRelatedReportSlice.reducer;
export const { clearState } = getRelatedReportSlice.actions;
